import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16.05,2A9.77,9.77,0,0,0,6.2,11.46,9.31,9.31,0,0,0,11,19.6V23a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V19.61a9.19,9.19,0,0,0,4.8-8.15A9.61,9.61,0,0,0,16.05,2Z"/><rect x="11" y="25" width="10" height="2" rx="1"/><rect x="12" y="28" width="8" height="2" rx="1"/>';
export var BulbSVG = function BulbSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BulbSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BulbSVG);